// extracted by mini-css-extract-plugin
module.exports = {"container":"FooterLogo_container__2-9nH","poweredBy":"FooterLogo_poweredBy__14pZ3"};